// ============================================================
// FILE: src/index.js
// PURPOSE: Entry point — mounts the React app into the HTML page
// DO NOT EDIT this file unless you know what you are doing
// ============================================================

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
